import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../../app/store';
import { updateSelectedContract } from '../../../../../../services/ContractService/contractSlice';

const FlatRateEditor: React.FC = () => {
  const dispatch = useAppDispatch();
  const contract = useAppSelector((state) => state.contract.currentContract);

  const handleChange = (value: string) => {
    if (!contract) return;

    let processedValue: number | null = null;
    if (value !== '' && value !== null) {
      processedValue = parseFloat(value) || null;
    }

    dispatch(updateSelectedContract({
      unspecified: {
        ...contract.unspecified,
        flatRate: processedValue
      }
    }));
  };

  if (!contract) return null;

  return (
    <TextField
      label="Flat Rate"
      value={contract.unspecified?.flatRate || ''}
      onChange={(e) => handleChange(e.target.value)}
      type="number"
      inputProps={{
        step: 0.01,
        min: 0
      }}
      fullWidth
      size="small"
      variant="outlined"
      helperText="Fixed rate amount for unspecified services"
    />
  );
};

export default FlatRateEditor;